export function initVideoHeroComponent() {
    const modal = document.querySelector(".video-hero-modal");
    const closeBtn = document.querySelector(".video-hero-close");
    const content = document.querySelector(".video-wrapper");
    const openButtons = document.querySelectorAll(".open-video-btn");

    if (!modal || !closeBtn || !content || openButtons.length === 0) {
        return;
    }

    function openModal() {
        modal.style.display = "flex";
        closeBtn.focus();
    }

    function closeModal() {
        modal.style.display = "none";

        const video = modal.querySelector("video");
        if (video) {
            video.pause();
            video.currentTime = 0;
        }
    }

    openButtons.forEach((btn) => btn.addEventListener("click", openModal));
    closeBtn.addEventListener("click", closeModal);

    modal.addEventListener("click", (e) => {
        if (!content.contains(e.target)) closeModal();
    });

    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") closeModal();
    });
}
